import { render, staticRenderFns } from "./CreateSO.vue?vue&type=template&id=98b71b0c&"
import script from "./CreateSO.vue?vue&type=script&lang=js&"
export * from "./CreateSO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports